"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e={headers:{}},t=require("react").createContext(e);exports.SwiggyHeadersContext=t;//# sourceMappingURL=index.js.map
